import React, { useState } from "react";
import "./ContactUs.css";
import axios from "axios";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaUser,
  FaCommentDots,
} from "react-icons/fa";

const contactCards = [
  {
    title: "Email ID",
    info: "budgetgoldentriangletours@gmail.com",
    icon: <FaEnvelope className="ycontact-card-icon" />,
  },
  {
    title: "Phone",
    info: "+91-9911363366",
    icon: <FaPhoneAlt className="ycontact-card-icon" />,
  },
  {
    title: "Address",
    info: "Flat No: 34D, Block H, Saket, New Delhi - 110017",
    icon: <FaMapMarkerAlt className="ycontact-card-icon" />,
  },
];

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [statusMessage, setStatusMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name || !formData.email || !formData.message) {
    setStatusMessage("Please fill in all required fields.");
    return;
  }

  try {
    const response = await axios.post(
      "https://eweblinktechnology.com/api/send-contact",
      formData, // <-- correct body
      { headers: { "Content-Type": "application/json" } }
    );

    if (response.data.success) {
      setStatusMessage("Message sent successfully!");
      setFormData({ name: "", email: "", phone: "", message: "" });
    } else {
      setStatusMessage("Failed to send message. Please try again.");
    }
  } catch (error) {
    console.error("Error sending contact message:", error);
    setStatusMessage("Something went wrong. Please try again later.");
  }
};

  return (
    <section className="ycontact-us">
      {/* Header */}
      <div className="ycontact-us-header">
        <h2 className="ycontact-us-title">Contact Us</h2>
        <p className="ycontact-us-subtitle">
          Feel free to reach out with any questions or inquiries!
        </p>
      </div>

      {/* Cards */}
      <div className="ycontact-us-cards">
        {contactCards.map((card, idx) => (
          <div
            key={idx}
            className="ycontact-us-card"
            style={{ animationDelay: `${idx * 0.2}s` }}
          >
            <div className="ycontact-card-icon-container">{card.icon}</div>
            <h4>{card.title}</h4>
            <p>{card.info}</p>
          </div>
        ))}
      </div>

      {/* Form & Map */}
      <div className="ycontact-us-form-map">
        {/* Form */}
        <div className="ycontact-us-form">
          <form className="ycontact-form" onSubmit={handleSubmit}>
            <h3>Get in Touch</h3>

            <div className="ycontact-input-group">
              <FaUser className="ycontact-icon" />
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="ycontact-input-group">
              <FaPhoneAlt className="ycontact-icon" />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="ycontact-input-group">
              <FaEnvelope className="ycontact-icon" />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="ycontact-textarea-group">
              <FaCommentDots className="ycontact-textarea-icon-inside" />
              <textarea
                name="message"
                placeholder="Your Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button type="submit">Send Message</button>
            {statusMessage && <p className="form-status">{statusMessage}</p>}
          </form>
        </div>

        {/* Map */}
        <div className="ycontact-us-map">
        <iframe
          src="https://www.google.com/maps?q=Flat%20No%2034D%2C%20Block%20H%2C%20Saket%2C%20New%20Delhi%20110017&output=embed"
          width="100%"
          height="600"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="City Linkers Tours & Travels - Saket New Delhi"
        ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
